import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useOverlayContext } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { ErrorResponse, errorTextsPath } from '~/infra/ErrorResponse';
import { handlePromise } from '~/infra/utils';
import { useStoreActions } from '~/store/store-context';
import { nativeUserIdOf } from '../../ContactsDashboardRow.utils';
import { EmailChangeConfirmation } from '../components/EmailChangeConfirmation';
export const useEmailChangeGuard = (testIds)=>{
    const { t } = useLocaleKeys('components.manageContactModalForVendor');
    const { t: commonButtons } = useLocaleKeys('common.buttons');
    const { t: errorTexts } = useLocaleKeys(errorTextsPath);
    const { showModal, showErrorToast } = useOverlayContext();
    const { api } = useStoreActions();
    const anchorUserWarning = {
        title: t.changesToExistingTitle(),
        description: t.updateEmailDescription(),
        confirmLabel: t.proceedAnyway(),
        cancelLabel: commonButtons.cancel(),
        biPrefix: 'edit_contact_identity_update_email',
        testId: testIds.anchorUserWarning
    };
    const withdrawWarning = {
        title: t.proposalsAwaitingTitle(),
        description: t.withdrawProposalsDescription(),
        confirmLabel: t.saveChangesAndWithdraw(),
        cancelLabel: commonButtons.back(),
        biPrefix: 'edit_contact_identity_withdraw_proposals',
        testId: testIds.withdrawProposals
    };
    const confirm = (props)=>showModal({
            biName: "".concat(props.biPrefix, "_modal"),
            closeOnClickOutside: true,
            closeOnEscapeKey: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(EmailChangeConfirmation, _object_spread_props(_object_spread({}, props), {
                    onResolve: dismissModal
                }));
            }
        });
    const affectedProposalIds = async (contactId)=>{
        const affected = await handlePromise(api.contactProposals.preview(contactId));
        if (affected.success) return affected.data.proposalIds;
        showErrorToast(new ErrorResponse(affected.error).saveContactErrorText(errorTexts), testIds.errorToast);
        return null;
    };
    const withdrawAffectedProposals = async (contactId)=>{
        const proposalIds = await affectedProposalIds(contactId);
        if (proposalIds == null) return 'cancel';
        if (proposalIds.length === 0) return 'proceed';
        if (!await confirm(withdrawWarning)) return 'cancel';
        await api.contactProposals.withdraw(contactId);
        return 'proceed';
    };
    return async (contact, newEmail)=>{
        if (newEmail.trim() === contact.email.trim()) return 'proceed';
        if (nativeUserIdOf(contact) != null && !await confirm(anchorUserWarning)) return 'cancel';
        return withdrawAffectedProposals(contact.contactId);
    };
};
